import React from 'react';
import { cn } from 'utils';
import { AntifadeContainer } from 'common/components/section-vlimit/fade-container/fade-container';
import { pdpSectionHideNoContent, pdpSectionStyle } from 'common/components/page-section';
import { CarouselMobilePadding, Styles } from 'pages/product-details/styles';
import { ProductCarousel } from 'features/products-carousel';
import { getSuggestionsPlacementId } from 'features/related-products/selectors';
import { useSelector } from 'react-redux';
import { DEFAULT_KZ_REGION, getRegionCode } from 'common/selectors';

type PdpSuggestionsGoodsProps = {
  productId: string;
};

export const PdpSuggestionsGoods = ({ productId }: PdpSuggestionsGoodsProps) => {
  const suggestionsPlacementId = useSelector(getSuggestionsPlacementId);

  const region = useSelector(getRegionCode);

  if (region === DEFAULT_KZ_REGION || suggestionsPlacementId === '') return null;

  return (
    <section className={cn(Styles.pdpSectionInsideInfoBlockStyle, pdpSectionStyle, pdpSectionHideNoContent)}>
      <AntifadeContainer />
      <CarouselMobilePadding>
        <ProductCarousel
          title="Рекомендации для вас"
          carouselId="recommendedProducts"
          placementId={suggestionsPlacementId}
          productId={productId}
          limitMax={30}
        />
      </CarouselMobilePadding>
    </section>
  );
};
